import { createBrowserHistory } from 'history';
const history = createBrowserHistory({ forceRefresh: true });
// history.go(0);
export default history;
